export default __webpack_public_path__ + "static/media/image9.22fb8838.png";